import apiClient from '@u/apiClient'

export default {
  enaosEligibleFuneralHomes({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`funeral-home/enaos-eligible`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getSalesExportByFuneralHome({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`funeral-home/${payload.funeral_home_id}/enaos/sales-export`, {
          params: payload.params
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getSalesExportInfoDossier({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(
          `funeral-home/${payload.funeral_home_id}/enaos/sales-export/info`,
          {
            params: payload.params
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  storeNewSupplierOrderForEnaosItem({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(
          `funeral-home/${payload.funeral_home_id}/enaos/sales-export/supplier-order`,
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  storeNewInvoiceForEnaosItemFromFuneralHome({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(
          `/funeral-home/${payload.funeral_home_id}/enaos/sales-export/invoice`,
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.error('Erreur storeNewInvoiceForEnaosItem:', error)
          reject(error)
        })
    })
  }
}
